import React from "react";
import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

import {
  HubHookFormInput,
  HubHookFormRoleSelect,
  HubHookFormSwitch,
} from "../../components";

const CreateEmployeeAccount = ({ isUpdate = false }) => {
  const { watch } = useFormContext();
  const locationId = watch("locationId") || 1;

  return (
    <Stack gap="15px" width="100%">
      <Typography variant="boldCaptionMain">Account Details</Typography>
      <Stack gap="15px">
        <Stack gap="15px">
          {!isUpdate && (
            <HubHookFormInput
              name="email"
              label="Confirm Email"
              placeholder="christopher@ipcfoundry.com"
              disabled
              required
            />
          )}
          <HubHookFormRoleSelect
            name="roleId"
            label="Role"
            locationId={locationId}
            useDefault={true}
            required
          />
        </Stack>
        {!isUpdate && (
          <Stack
            direction="row"
            gap="15px"
            height="59.31px"
            alignItems="center"
          >
            <HubHookFormSwitch
              name="invite"
              label="Send Invite Email to new user?"
              labelPlacement="end"
              isCheckbox
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default CreateEmployeeAccount;
